import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { compose } from 'utils/react';
import {
  loadPage,
  getSelectedPage,
  loadParentPage,
  getParentPage,
} from 'store/modules/pageSettings';
import { save as saveSite } from 'store/modules/site';
import { getCompanyId, getLocales } from 'store/modules/company';
import { getHostnames } from 'store/modules/hostnames';
import { getShowApplicableFees } from 'store/modules/site';
import gql from 'graphql-tag';
import { BLOG_HOME_PAGE } from 'shared/pageTypes';
import PageSettings from '../components/PageSettings';
import useSearchablePages from '../../../../../admin/hooks/useSearchablePages';
import { PAGE_SETTINGS_PAGE_DROPDOWN_COUNT } from '../../../../../constants/admin';
import { DEFAULT_LOCALE } from '../../../../../modules/i18n/locales';
import { update as updateFacility } from 'store/modules/facilities';

const GET_PAGES = gql`
  query PageSettingsPagesData($fulltext: String, $locale: String, $first: Int!, $excludeTypes: [String!]) {
    pages(filter: {
      fulltext: $fulltext,
      locale: $locale,
      excludeTypes: $excludeTypes,
    }, first: $first) {
      ...PageSettingsPageDropdownPagesConnection
    }
  }
  ${PageSettings.fragments.pagesConnection}
`;

const propTypes = {
  selectedPage: PropTypes.shape({
    locale: PropTypes.string,
  }),
};
const defaultProps = {
  selectedPage: undefined,
};

const PageSettingsData = ({ selectedPage, ...rest }) => {
  const [dataState, { onChange }] = useSearchablePages(
    GET_PAGES,
    ({ fulltext }) => ({
      variables: {
        first: PAGE_SETTINGS_PAGE_DROPDOWN_COUNT,
        fulltext,
        locale: selectedPage && selectedPage.locale ? selectedPage.locale : DEFAULT_LOCALE,
        excludeTypes: [BLOG_HOME_PAGE],
      },
    }),
  );
  const { loading, pages } = dataState;

  return (
    <PageSettings
      pages={pages}
      loading={loading}
      onSearch={onChange}
      selectedPage={selectedPage}
      {...rest}
    />
  );
};

PageSettingsData.propTypes = propTypes;
PageSettingsData.defaultProps = defaultProps;

export default compose(
  connect(
    state => ({
      pageId: state.routing.locationBeforeTransitions.query.page,
      selectedPage: getSelectedPage(state),
      parentPage: getParentPage(state),
      hostnames: getHostnames(state),
      languages: getLocales(state),
      companyId: getCompanyId(state),
      showApplicableFees: getShowApplicableFees(state),
    }),
    {
      pushRoute: push,
      loadPage,
      loadParentPage,
      saveSite,
      updateFacility,
    },
  ),
)(PageSettingsData);
